import type { TenantAccount } from "@/types/tenant";

import type { QueryClient, UseQueryReturnType as _ } from "@tanstack/vue-query";

export function useTenantAccountList(enabled: boolean | globalThis.Ref<boolean>) {
  const { maybeGetFromCacheAndRefetch, setCachedData } = useApiCache();
  const request = useQuery({
    queryKey: ["tenant", "account-list"],
    queryFn: async () => {
      const { cachedData, isInitialized } = maybeGetFromCacheAndRefetch(
        "tenantAccountList",
        ["tenant", "account-list"]
      );
      if (cachedData && !isInitialized) return cachedData;
      const { data } = await useGetRequest<{ items: TenantAccount[] }>(
        `/account/sub-accounts`
      );
      if (data?.items) {
        setCachedData("tenantAccountList", data.items);
      }
      return data?.items || null;
    },
    staleTime: 3 * 60 * 1000,
    enabled,
  });

  return request;
}

export function removeTenantAccountFromQueryCache(
  accountId: string,
  queryClient: QueryClient
) {
  queryClient.setQueryData(
    ["tenant", "account-list"],
    (oldData: TenantAccount[] | undefined) => {
      if (!oldData) return oldData;
      return oldData.filter(account => account.id !== accountId);
    }
  );
}
